export default __webpack_public_path__ + "static/media/KardiaComplete.c43b9234.png";